import { Button, Table as BootstrapTable } from 'react-bootstrap';

import React from 'react';

import Icon from "../../../../components/Icon";

import moment from "moment";
import sort from "array-sort";

const Table = ({ data, history, remove, edit }) => {
    const [ state, setState ] = React.useState({
        data: [],
        sorting: {
            order: null,
            field: null,
        }
    });

    React.useEffect(() => {
        if (data.length) setState({ ...state, data, sorting: { order: null, field: null } });
    }, [ data ]);

    React.useEffect(() => {
        if (!state.sorting.order && !state.sorting.field) return;

        const sorted = sort(state.data, state.sorting.field, { reverse: state.sorting.order === 'desc' });

        setState({ ...state, data: sorted });
    }, [ state.sorting.order, state.sorting.field ]);

    const on_sort = (field) => {
        const sorting = state.sorting;

        if (sorting.field === field) {
            sorting.order = sorting.order === 'asc' ? 'desc' : 'asc';
        } else {
            sorting.order = 'asc';
            sorting.field = field;
        }

        return setState({ ...state, sorting });
    };

    const format_antivirus_results = (service, results = []) => {
        if (service === 'virustotal') return results.map((result) => result.description && <p><b>{result.request} -</b> {result.description}</p>);

        return results.map((result) => result.description);
    }

    return (
        <BootstrapTable bordered responsive style={{ textAlign: 'center', verticalAlign: 'middle' }}>
            <thead style={{ background: 'whitesmoke' }}>
                <tr>
                    <th onClick={() => on_sort('subdomain')}>Subdomain</th>
                    <th onClick={() => on_sort('domain')}>Domain</th>
                    <th onClick={() => on_sort('hour')}>Hour</th>
                    <th onClick={() => on_sort('type')}>Type</th>
                    <th onClick={() => on_sort('flagged')}>Flagged</th>
                    <th onClick={() => on_sort('flagged_at')}>Flagged At</th>
                    <th onClick={() => on_sort('checked_at')}>Checked At</th>
                    <th onClick={() => on_sort('antiviruses.virustotal')}>Virus Total</th>
                    <th onClick={() => on_sort('antiviruses.sucuri')}>Sucuri</th>
                    <th onClick={() => on_sort('antiviruses.avast')}>Avast</th>
                    <th onClick={() => on_sort('antiviruses.google_interstitial')}>Google Interstitial</th>
                    <th onClick={() => on_sort('antiviruses.google_safe_browsing')}>Google Safe Browsing</th>
                    <th style={{ width: '12%' }} onClick={() => on_sort('note')}>Note</th>
                    <th style={{ width: '8%' }}>Action</th>
                </tr>
            </thead>

            <tbody>
                {
                    state.data.map((row) => {
                        return (
                            <tr>
                                <td>{row.subdomain}</td>
                                <td style={{ color: row.flagged ? 'red' : 'black', fontWeight: row.flagged ? 'bold' : 'normal' }}>{row.domain}</td>
                                <td>{row.hour}</td>
                                <td>{row.type}</td>
                                <td>{row.flagged}</td>
                                <td>{row.flagged_at ? moment.unix(row.flagged_at).utc().format(`YYYY-MM-DD HH:mm`) : ""}</td>
                                <td>{row.checked_at ? moment.unix(row.checked_at).utc().format(`YYYY-MM-DD HH:mm`) : ""}</td>
                                <td>{format_antivirus_results("virustotal", row.antiviruses.virustotal)}</td>
                                <td>{format_antivirus_results("sucuri", row.antiviruses.sucuri)}</td>
                                <td>{format_antivirus_results("avast", row.antiviruses.avast)}</td>
                                <td>{format_antivirus_results("google_interstitial", row.antiviruses.google_interstitial)}</td>
                                <td>{format_antivirus_results("google_safe_browsing", row.antiviruses.google_safe_browsing)}</td>
                                <td>{row.note}</td>
                                <td>
                                    <Button bsStyle={'success'} style={{ margin: '3px' }} onClick={() => history(row)}><Icon name={"history"} /></Button>
                                    <Button bsStyle={'primary'} style={{ margin: '3px' }} onClick={() => edit(row)}><Icon name={"edit"} /></Button>
                                    <Button bsStyle={'danger'} style={{ margin: '3px' }} onClick={() => remove(row)}><Icon name={"remove"} /></Button>
                                </td>
                            </tr>
                        )
                    })
                }
            </tbody>
        </BootstrapTable>
    )
};

export default Table;



// WEBPACK FOOTER //
// ./src/scenes/DomainsV2/components/Table/index.js